import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import WarrantyEditor from './WarrantyEditor';

function NewWarranty() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();
	const backTo = returnTo || `/AdminScreen/credits/credit/${id}`;

	return (
		<EntityList>
			<Helmet>
				<title>Nueva Garantía</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pasividades', to: '/AdminScreen/credits' },
					{ label: 'Nueva garantía' },
				]}
				title='Nueva Garantía'
				subtitle='Completá los datos para crear la garantía.'
			/>
			<WarrantyEditor
				preloadCreditId={id}
				onCancel={() => navigate(backTo)}
				onSaved={() => navigate(backTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewWarranty;
